import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Box from '@mui/material/Box'

const BADGE_BG = '#fffbeb'
const BADGE_BORDER = '#fbbf24'
const BADGE_TEXT = '#b45309'
const BADGE_ICON = '#d97706'

/** Per-question pill — template-origin indicator in the config panel (Figma lock-badge layout). */
export function QuestionFromTemplateBadge() {
  return (
    <Box
      component="span"
      data-testid="question-from-template-badge"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        px: '10px',
        py: '4px',
        borderRadius: '9999px',
        border: `1px solid ${BADGE_BORDER}`,
        bgcolor: BADGE_BG,
        fontFamily: '"Inter", sans-serif',
        fontWeight: 500,
        fontSize: '12px',
        lineHeight: '16px',
        color: BADGE_TEXT,
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 14, color: BADGE_ICON }} aria-hidden />
      From template
    </Box>
  )
}
